import React, {useEffect, useState} from "react";
import general from "../../../general";
import {Link} from "react-router-dom";
import $ from "jquery";
import {PlayCircleOutlined} from '@ant-design/icons';
import {useScroll} from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import useActiveState from '../../../lib/useActiveState';
import Subtitle from "../../components/Subtitle";
import './css/reserve.css';

export default props => {
  
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const [user] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [randomColorInfo] = useActiveState('randomColorInfo');
  
  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    if (!init) {
      setLoading(true);
    }
    Dialog.loading();
    let tmp = {
      pagination: {page: page},
    };
    if (parms.page) {
      tmp.pagination = {page: parms.page};
    }
    general.axios.post('/reservedGames', tmp)
        .finally(() => {
          setLoading(false);
          Dialog.close();
          parms.finishPullUp && parms.finishPullUp();
          parms.finishPullDown && parms.finishPullDown();
        })
        .then(response => {
          setInit(true);
          let result = response.data.data;
          if (parms.page) {
            setPage(parms.page);
          }

          result.game_list.forEach(d => {
            d.infoColor = randomColorInfo[parseInt(Math.random() * 4)]
          })
          setGames(games => parms.page === 1 || !parms.page ? result.game_list : [...games, ...result.game_list]);
          setMore(result.paginated.more);
        })
        .catch(err => {
          Dialog.error(err.message);
        });
  }

  useEffect(() => {
    if (props.active) {
      load();
    }
  }, [props.active]);

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll.top < -80) {
        load({page: 1});
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        load({page: page + 1});
      }
    }
  }, [scroll, props.active]);

  const clickGameOfTheNewGame = (game) => {
 
  }

  const reserve = (game) => {    
    general.axios.post(game.is_reserved ? '/cancelReserveGame' : '/reserveGame', {id: game.maiyou_gameid})
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let result = res.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          let message = game.is_reserved ? '取消成功' : '预约成功';
          Dialog.success(message);
          load()
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  };

  return <div className="new-my-reserve">
  {games.map(game => <div className="new-my-reserve-item">
    <Link to={'/game?id=' + game.game_id} className="subject">
      <div className="icon">
        <Image src={game.game_image.thumb}/>
        {
          game?.lablePosition == 2 && game.top_lable != '' ?
          <div className="iconlable jx" style={{backgroundImage: 'linear-gradient('+game?.lableColor.t+', '+game?.lableColor.b+')'}}>
            {game.top_lable}
          </div>
          : null
        }
      </div>
      <div className="text">
        <div className="name">
          <div className={"named " + (game.nameRemark ? " name-new" : "")}>{game.game_name}</div>
          {game.nameRemark != '' ? <div className="nameRemark-new">{game.nameRemark}</div> : null}
          {/* <div className="date">{moment(game.starting_time * 1000).format('MM-DD HH:mm')}首发</div> */}
        </div>
        <div className="info1">
          {/* {
            game.nameRemark ?
            <span className="nameRemark">
              {game?.nameRemark}&nbsp;
            </span>
            : <>{game.game_classify_type.trim()}</>
          } */}
          {game.game_classify_type.trim()}
          <div className="reserve">{game.reserved_total}人预约</div>
          {/* <div className="date">{moment(game.starting_time * 1000).format('MM-DD HH:mm')}首发</div> */}
          <div className="date">{game.label}</div>
        </div>
        <div className="info2">
          {/* {game.game_desc.split('+').map(item => <div className="tag">{item}</div>)} */}
          {game.game_desc ? <>{game.game_desc?.split('+').map(item => <div className="tag">{item}</div>)}</> : <>{game.introduction}</>}
        </div>
      </div>
      
      {/* <div className="btn">{game.game_species_type == 3 ? "开始" : "查看"}</div> */}
    </Link>
    <div className="medias clearfix">
      <Link to={'/video?url=' + game.video_url} className="media">
        <div className="container">
          <Image src={game.game_ur_list[0]} alt=""/>
          <PlayCircleOutlined className="play"/>
        </div>
      </Link>
      {[game.game_ur_list[0],game.game_ur_list[1],game.game_ur_list[2],game.game_ur_list[3]].map((img, index, imgs) => img ? <Link className="media" to={'/img?imgs=' + imgs + '&img=' + index}>
        <Image src={img} alt=""/>
      </Link> : null)}
    </div>
  </div>)}
  {games.length > 6 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
</div>;
};